// extracted by mini-css-extract-plugin
export default {"AnnualIncome":"HeadlessDueDeligence_AnnualIncome__AZLPW"};